import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

export const TopBarRoot = styled(AppBar)(({ theme }) => ({
  backgroundColor: '#fff',
  boxSizing: 'border-box',
  borderRadius: '18px',
  boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.06)',
  // Match the horizontal margin of ContentArea so edges align
  marginLeft: theme.spacing(1.5),
  marginRight: theme.spacing(1.5),
  marginBottom: theme.spacing(1.5),
  // AppBar is position:static inside MainArea — override MUI's default width calc
  width: 'auto',
}));

export const TopBarToolbar = styled(Toolbar)({
  minHeight: 56,
  paddingLeft: 16,
  paddingRight: 24,
  alignItems: 'center',
});

export const TopBarLogoWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
});

export const TopBarLogo = styled('img')({
  height: 20,
  width: 'auto',
  display: 'block',
});

export const TopBarWorkspaceName = styled(Typography)({
  marginLeft: 10,
  fontSize: 13,
  lineHeight: 1,
}) as typeof Typography;

export const TopBarSpacer = styled(Box)({
  flexGrow: 1,
});

export const TopBarAvatar = styled(Avatar)(({ theme }) => ({
  width: 32,
  height: 32,
  fontSize: 13,
  fontWeight: 600,
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.primary.main,
}));
